import { FilterPanelRoot } from "./filter-panel";
import { FilterPanelActiveChips } from "./parts/active-chips";
import { FilterPanelAddButton } from "./parts/add-button";
import { FilterPanelRow } from "./parts/filter-row";
import { FilterPanelFooter } from "./parts/footer";
import { FilterPanelSaveButton } from "./parts/save-button";
import { FilterPanelSaveDialog } from "./parts/save-filter-dialog";
import { FilterPanelSavedList } from "./parts/saved-list";
import { FilterPanelCard } from "./parts/view-card";
import { FilterPanelHeader } from "./parts/view-header";
import { FilterPanelRows } from "./parts/view-rows";

export {
  buildRows,
  completeFilterValue,
  dateRangeToValues,
  hasFilterCriteria,
  isRowComplete,
  monthRangeToValues,
  pruneFilterValue,
  serializeFilterValue,
  validateSavedFilterName,
  valuesToDateRange,
  valuesToMonthRange,
} from "./filter-panel.model";
export * from "./messages";
export * from "./active-chips.messages";
export type * from "./types-filter-panel";

/** Painel de filtros composto: `Root` guarda o estado; `Card`, `Header`, `Rows`/`Row`, `AddButton` e `Footer` o desenham. */
export const FilterPanel = {
  Root: FilterPanelRoot,
  Card: FilterPanelCard,
  Header: FilterPanelHeader,
  Rows: FilterPanelRows,
  Row: FilterPanelRow,
  AddButton: FilterPanelAddButton,
  Footer: FilterPanelFooter,
  SavedList: FilterPanelSavedList,
  SaveButton: FilterPanelSaveButton,
  SaveDialog: FilterPanelSaveDialog,
  ActiveChips: FilterPanelActiveChips,
};
